/**
 * 突发性线索
 * 2017-11-9
 * Bai.Zhiming
 */
"use strict";
angular.module("suddenCluesModule", [
    "suddenCluesRouterModule", //突发性线索总路由
    "newsMonitorModule", //爆料监控模块
    "zjPublicopinionModule", //新疆舆情模块
    "disasterAccidentModule", //灾害事故模块
    "customSentimentModule", //自定义舆情
]);